/**
 * "Find your size" panel controller (markup: snippets/fit-finder.liquid,
 * size logic: assets/fit-finder-core.js).
 */
(function () {
  const dialog = document.getElementById('fit-finder');
  const dataEl = document.getElementById('fit-finder-data');
  const Core = window.FitFinderCore;
  if (!dialog || !dataEl || !Core) return;

  const DATA = JSON.parse(dataEl.textContent);
  const fmt = (s, v) => s.replace('%s', v);
  const STEPS = ['gender', 'body', 'shape', 'fit', 'result'];
  const KEY = '2side-fit';
  const DEFAULTS = {
    male: { heightCm: 178, weightKg: 75 },
    female: { heightCm: 165, weightKg: 58 },
  };

  const $ = (sel) => dialog.querySelector(sel);
  const $$ = (sel) => [...dialog.querySelectorAll(sel)];
  const track = $('.fit-finder__track');
  const nextBtn = $('[data-fit-next]');
  const backBtn = $('[data-fit-back]');
  const restartBtn = $('[data-fit-restart]');

  let picker = null; // the fieldset that opened the panel
  let step = 0;
  let state = load() || { units: { h: 'cm', w: 'kg' }, chest: 'average', stomach: 'average', hips: 'average', fit: 'regular' };

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  const complete = (s) => s && s.gender && s.heightCm && s.weightKg && s.fit;

  /* ---------- icons ---------- */
  function torso(area, level, female) {
    // Width at shoulder, chest, waist, hip rows (half-widths around x=50).
    const w = female ? [26, 22, 15, 24] : [30, 26, 21, 23];
    const rows = [18, 38, 64, 92];
    const idx = { chest: 1, stomach: 2, hips: 3 }[area];
    if (idx !== undefined) w[idx] += level * 8;
    const pt = (i, side) => `${50 + side * w[i]},${rows[i]}`;
    const d = `M${pt(0, -1)} Q50,12 ${pt(0, 1)} C${50 + w[0]},28 ${pt(1, 1)} ${pt(1, 1)} S${pt(2, 1)} ${pt(2, 1)} S${pt(3, 1)} ${pt(3, 1)} L${pt(3, -1)} S${pt(2, -1)} ${pt(2, -1)} S${pt(1, -1)} ${pt(1, -1)} C${50 - w[1]},${rows[1]} ${50 - w[0]},28 ${pt(0, -1)} Z`;
    const zone = idx === undefined ? '' :
      `<ellipse class="ff-zone" cx="50" cy="${rows[idx]}" rx="${w[idx] - 3}" ry="7"/>`;
    const head = `<circle cx="50" cy="6" r="6" fill="none" stroke="currentColor" stroke-width="1.6"/>`;
    return `<svg viewBox="0 -2 100 100" aria-hidden="true">${head}${zone}<path d="${d}" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>`;
  }
  function tee(level) {
    const b = 26 + level * 7; // half body width
    const s = b + 14;
    return `<svg viewBox="0 0 100 84" aria-hidden="true"><path d="M${50 - b + 2},8 L${50 - s},20 L${50 - s + 6},36 L${50 - b},30 L${50 - b},80 L${50 + b},80 L${50 + b},30 L${50 + s - 6},36 L${50 + s},20 L${50 + b - 2},8 Q50,20 ${50 - b + 2},8 Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`;
  }
  function drawIcons() {
    const female = state.gender === 'female';
    $$('[data-fig]').forEach((el) => {
      const lvl = +el.dataset.level || 0;
      el.innerHTML =
        el.dataset.fig === 'male' ? torso(null, 0, false) :
        el.dataset.fig === 'female' ? torso(null, 0, true) :
        el.dataset.fig === 'tee' ? tee(lvl) :
        torso(el.dataset.area, lvl, female);
    });
  }

  /* ---------- body step ---------- */
  const range = { h: $('[data-range="h"]'), w: $('[data-range="w"]') };
  const out = { h: $('[data-out="h"]'), w: $('[data-out="w"]') };
  function renderBody() {
    range.h.value = state.heightCm;
    range.w.value = state.weightKg;
    const [ft, inch] = Core.cmToFtIn(state.heightCm);
    out.h.textContent = state.units.h === 'ft' ? `${ft}′ ${inch}″` : `${state.heightCm} cm`;
    out.w.textContent = state.units.w === 'lb' ? `${Core.kgToLb(state.weightKg)} lb` : `${state.weightKg} kg`;
    $$('[data-unit]').forEach((b) => b.classList.toggle('is-selected', state.units[b.dataset.unit] === b.dataset.value));
  }
  range.h.addEventListener('input', () => { state.heightCm = +range.h.value; renderBody(); });
  range.w.addEventListener('input', () => { state.weightKg = +range.w.value; renderBody(); });

  /* ---------- result ---------- */
  function offeredSizes() {
    return picker ? [...picker.querySelectorAll('input[type=radio]')].map((i) => i.value) : [];
  }
  function chartFor(type) {
    return Core.parseChart(/baby/i.test(type || '') ? DATA.charts.baby : DATA.charts.regular);
  }
  function result() {
    const chart = chartFor(picker && picker.dataset.fitType);
    return Core.recommend(state, chart, offeredSizes());
  }
  function renderResult() {
    const r = result();
    $('[data-result-size]').textContent = r.size;
    $('[data-result-detail]').textContent = fmt(DATA.t.estimate, r.chest);
    const input = picker && [...picker.querySelectorAll('input[type=radio]')].find((i) => i.value === r.size);
    const soldOut = input && input.dataset.optionAvailable === 'false';
    const warn = $('[data-result-warn]');
    warn.hidden = !soldOut;
    warn.textContent = soldOut ? fmt(DATA.t.soldOut, r.size) : '';
    nextBtn.textContent = fmt(DATA.t.select, r.size);
    nextBtn.disabled = !input || soldOut;
  }

  /* ---------- navigation ---------- */
  const answered = () => ({
    gender: !!state.gender,
    body: true,
    shape: !!(state.chest && state.stomach && state.hips),
    fit: !!state.fit,
    result: true,
  }[STEPS[step]]);

  function go(n) {
    step = Math.max(0, Math.min(STEPS.length - 1, n));
    track.style.setProperty('--ff-step', step);
    dialog.style.setProperty('--ff-progress', `${((step + 1) / STEPS.length) * 100}%`);
    $$('.fit-finder__step').forEach((s, i) => {
      s.classList.toggle('is-current', i === step);
      s.inert = i !== step;
    });
    backBtn.hidden = step === 0;
    restartBtn.hidden = STEPS[step] !== 'result';
    if (STEPS[step] === 'body') renderBody();
    if (STEPS[step] === 'result') { save(); renderResult(); refreshHints(); }
    else { nextBtn.textContent = DATA.t.next; nextBtn.disabled = !answered(); }
  }

  function markSelected() {
    $$('[data-group]').forEach((g) => {
      [...g.querySelectorAll('[data-value]')].forEach((b) => b.classList.toggle('is-selected', state[g.dataset.group] === b.dataset.value));
    });
  }

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) return dialog.close(); // backdrop
    const choice = e.target.closest('[data-group] [data-value]');
    if (choice) {
      const group = choice.closest('[data-group]').dataset.group;
      state[group] = choice.dataset.value;
      if (group === 'gender') {
        // Start the sliders near this gender's average until the shopper
        // has set their own numbers.
        if (!state._bodySet) Object.assign(state, DEFAULTS[state.gender]);
        drawIcons();
      }
      markSelected();
      nextBtn.disabled = !answered();
      // single-question steps move on by themselves
      if (group === 'gender' || group === 'fit') setTimeout(() => go(step + 1), 280);
      return;
    }
    const unit = e.target.closest('[data-unit]');
    if (unit) { state.units[unit.dataset.unit] = unit.dataset.value; renderBody(); return; }
    if (e.target.closest('[data-fit-close]')) return dialog.close();
    if (e.target.closest('[data-fit-back]')) return go(step - 1);
    if (e.target.closest('[data-fit-restart]')) return go(0);
    if (e.target.closest('[data-fit-next]')) {
      if (STEPS[step] === 'body') state._bodySet = true;
      if (STEPS[step] !== 'result') return go(step + 1);
      const r = result();
      const input = [...picker.querySelectorAll('input[type=radio]')].find((i) => i.value === r.size);
      if (input && !input.checked) input.click();
      dialog.close();
    }
  });

  /* ---------- openers + "Your size: M" hints ---------- */
  function refreshHints() {
    const s = load();
    document.querySelectorAll('[data-fit-finder-open]').forEach((btn) => {
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      const fs = btn.closest('fieldset');
      let text = btn.dataset.label;
      if (complete(s) && fs) {
        const sizes = [...fs.querySelectorAll('input[type=radio]')].map((i) => i.value);
        text = fmt(DATA.t.hint, Core.recommend(s, chartFor(btn.dataset.fitType), sizes).size);
      }
      // Only write when it changes, so the observer below doesn't loop.
      if (btn.textContent.trim() !== text) btn.textContent = text;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fit-finder-open]');
    if (!btn) return;
    e.preventDefault();
    picker = btn.closest('fieldset');
    if (picker) picker.dataset.fitType = btn.dataset.fitType || '';
    drawIcons();
    markSelected();
    if (!state.heightCm) Object.assign(state, DEFAULTS[state.gender || 'male']);
    dialog.showModal();
    go(complete(state) ? STEPS.length - 1 : 0);
  });

  // Quick-add modals render their size picker later, and picking a variant
  // makes the theme re-render the picker from the server (resetting the
  // label text in place). Re-label after either.
  const touchesOpener = (m) => {
    const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (el && el.closest('[data-fit-finder-open]')) return true;
    return [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-fit-finder-open]') || n.querySelector('[data-fit-finder-open]')));
  };
  let queued = false;
  new MutationObserver((muts) => {
    if (queued || !muts.some(touchesOpener)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refreshHints(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  refreshHints();
})();
